const get = require('lodash/get')
const format = require('date-fns/format')

const getEarliestSnapshot = (history) => {
  const earliest = Object.entries(history).reduce((earliest, [key, value]) => {
    if (!earliest) return [key, value]
    if (!value.counts) return earliest
    return new Date(value.createdAt) < new Date(earliest[1].createdAt)
      ? [key, value]
      : earliest
  }, null)
  return earliest[1]
}

const buildShipmentItems = (shipmentCounts = {}, initialSnapshotCounts = {}, products) => {
  // Validate: received should never exceed packed (data integrity check)
  const invalidBatches = []
  Object.keys(shipmentCounts).forEach(batch => {
    const shipmentQuantity = (shipmentCounts[batch] || {}).quantity || 0
    const initialSnapshotQuantity = (initialSnapshotCounts[batch] || {}).quantity || 0
    if (shipmentQuantity > initialSnapshotQuantity) {
      const productId = batch.split(':manufacturer')[0]
      invalidBatches.push({
        batch,
        productId: productId.replace('product:', ''),
        packed: initialSnapshotQuantity,
        received: shipmentQuantity
      })
    }
  })

  if (invalidBatches.length > 0) {
    const errorDetails = invalidBatches.map(b =>
      `batch ${b.batch} (product: ${b.productId}): packed=${b.packed}, received=${b.received}`
    ).join('; ')
    throw new Error(`Data integrity error: received quantity exceeds packed quantity. ${errorDetails}`)
  }

  let isComplete = true
  const shipmentItems = Object.keys(shipmentCounts).map(batch => {
    const productId = batch.split(':manufacturer')[0]
    const shipmentCount = shipmentCounts[batch] || {}
    const initialSnapshotCount = initialSnapshotCounts[batch] || {}

    const shipmentQuantity = shipmentCount.quantity || 0
    const initialSnapshotQuantity = initialSnapshotCount.quantity || 0
    // After validation above, we know shipmentQuantity <= initialSnapshotQuantity
    // So returned will always be >= 0
    const returned = initialSnapshotQuantity - shipmentQuantity
    const rejectedQuantity = isNaN(returned) ? 0 : returned

    if (rejectedQuantity > 0) {
      isComplete = false
    }

    const product = products[productId] || {}

    return {
      npcCode: productId.replace('product:', '') || '',
      productDescription: product.name || '',
      batch: batch,
      deliveredQuantity: shipmentQuantity,
      acceptedQuantity: initialSnapshotQuantity,
      rejectedQuantity: rejectedQuantity,
      reason: rejectedQuantity > 0 ? 'Returned items' : ''
    }
  })

  return { shipmentItems, isComplete }
}
const transformRmsShipment = (shipment = {}, products = {}, locationsById = {}) => {
  const receivedDate = get(shipment, 'snapshotDates.received')

  const shipmentHistory = shipment.history || {}
  const initialSnapshot = getEarliestSnapshot(shipmentHistory)

  const { shipmentItems, isComplete } = buildShipmentItems(shipment.counts, initialSnapshot.counts, products)

  const destination = get(locationsById, shipment.destination.id, {})
  const destinationCode = get(destination, 'additionalData.warehouseCode', 'default-code')

  const data = {
    orderNo: shipment.orderId,
    customerCode: destinationCode,
    deliveryId: shipment.externalShipmentId || 'test-code',
    deliveryDate: format(new Date(receivedDate), 'DD/MM/YYYY HH:mm:ss'),
    deliveryStatus: isComplete ? 'C' : 'I',
    items: shipmentItems
  }
  return data
}

module.exports = { transformRmsShipment }
